namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.AddonDialog')
    export class AddonDialog extends Serenity.EntityDialog<AddonRow, any> {
        protected getFormKey() { return AddonForm.formKey; }
        protected getIdProperty() { return AddonRow.idProperty; }
        protected getLocalTextPrefix() { return AddonRow.localTextPrefix; }
        protected getNameProperty() { return AddonRow.nameProperty; }
        protected getService() { return AddonService.baseUrl; }
        protected getDeletePermission() { return AddonRow.deletePermission; }
        protected getInsertPermission() { return AddonRow.insertPermission; }
        protected getUpdatePermission() { return AddonRow.updatePermission; }

        protected form = new AddonForm(this.idPrefix);
    }
}